import { dispatcher, ingenuity } from "@quest/base-core";
import { BaseViewBehavior, SlotConstantsBehavior } from "@quest/murka-games-behavior-panther";
import { IEvent } from "@quest/adapter-interface";
import { eventDispatchers } from "../Constants/EventDispatchers";

export class HoldAndRespinWinCollectionView extends BaseViewBehavior {
  constructor(viewJson: JSON) {
    super(viewJson);
    this.subscribeEvent();
  }

  private subscribeEvent() {
    this.unSubscribeEvent();
    dispatcher.on(eventDispatchers.ADD_LIGHTNING_VIEW_ON_TOP, this.addWinCollectionViewOnTop, this);
  }
  private unSubscribeEvent() {
    dispatcher.off(eventDispatchers.ADD_LIGHTNING_VIEW_ON_TOP, this.addWinCollectionViewOnTop, this);
  }

  // Overrided to align view y position
  protected resize(evt: IEvent): void {
    super.resize(evt);
    if (ingenuity.deviceEnv.isDesktop) {
      this.y = innerHeight * SlotConstantsBehavior.HALF_CONVERTER + SlotConstantsBehavior.VIEW_SLIDE_DESKTOP;
    }
    dispatcher.fireEvent(eventDispatchers.UPDATE_FINAL_POSITION);
  }

  /**
   * Method to add win collection view on top
   */
  private addWinCollectionViewOnTop(): void {
    ingenuity.currentGame.stage.addChild(this);
  }

  /**
   * Method to destroy the view
   */
  public destroy(): void {
    super.destroy();
    this.unSubscribeEvent();
  }
}
